import ewcLogo from '@/assets/img/ewc-logo.png';
import confLogo from '@/assets/img/conference-logo.png';
import { createStore } from 'vuex'

export default createStore({
    state: {
        theme: 'Ewc',
        logo: ewcLogo
    },
    mutations: {
        setTheme(state, theme) {
            localStorage.setItem('theme', theme);
            state.theme = theme;
            const root = document.documentElement;

            var cssVars = {};
            if (theme != 'Ewc') {
                document.documentElement.style.setProperty('--hole-bg-color', "#222222");
                document.documentElement.style.setProperty('--conf-bg-color', "#222222");
                document.documentElement.style.setProperty('--main-color', "#d1b26f");
                document.documentElement.style.setProperty('--bs-body-bg', "#222222");
                document.documentElement.style.setProperty('--bg-color', "#222222");
                document.documentElement.style.setProperty('--section-padding-bg', "#222222");
                document.documentElement.style.setProperty('--bs-body-color', '#fff');

                document.documentElement.style.setProperty('--theme-search-form-bg', '#3a3a3a');
                document.documentElement.style.setProperty('--flight-search-items-bg', '#3a3a3a');
                document.documentElement.style.setProperty('--flight-search-bg', '#222222');
                document.documentElement.style.setProperty('--bs-secondary-bg', '#222222');
                document.documentElement.style.setProperty('--navbar-sticky-bg', '#222222');
                document.documentElement.style.setProperty('--flight-search-text-color', '#fff');
                document.documentElement.style.setProperty('--flight-search-input-color', '#fff');
                document.documentElement.style.setProperty('--dropdown-passenger-button-color', '#fff');

                document.documentElement.style.setProperty('--preloader-bg', "#222222");
                document.documentElement.style.setProperty('--loader-border-main', "#d1b26f");
                document.documentElement.style.setProperty('--loader-border-secondary', '#3a3a3a');

                document.documentElement.style.setProperty('--secondary-color', '#3a3a3a');
                document.documentElement.style.setProperty('--primary-color', '#231f20');

                document.documentElement.style.setProperty('--btn-theme-before-bg', '#222222');
                document.documentElement.style.setProperty('--input-bg-color', '#222222');
                document.documentElement.style.setProperty('--area-flex-one-text-color', '#fff');
                document.documentElement.style.setProperty('--flight-inner-show-color', '#fff');
                document.documentElement.style.setProperty('--input-color', '#fff');
                document.documentElement.style.setProperty('--paragraph-color', '#fff');
                document.documentElement.style.setProperty('--dp-background-color', '#3a3a3a');
                document.documentElement.style.setProperty('--flight-search-right-bg', '#555555');
                document.documentElement.style.setProperty('--flight-search-right-bg', '#555555');
                state.logo = confLogo;
            } else {
                document.documentElement.style.setProperty('--hole-bg-color', "#222222");
                document.documentElement.style.setProperty('--conf-bg-color', "#222222");
                document.documentElement.style.setProperty('--main-color', "#d1b26f");
                document.documentElement.style.setProperty('--bs-body-bg', "#222222");
                document.documentElement.style.setProperty('--bg-color', "#222222");
                document.documentElement.style.setProperty('--section-padding-bg', "#222222");
                document.documentElement.style.setProperty('--bs-body-color', '#fff');

                document.documentElement.style.setProperty('--theme-search-form-bg', '#3a3a3a');
                document.documentElement.style.setProperty('--flight-search-items-bg', '#3a3a3a');
                document.documentElement.style.setProperty('--flight-search-bg', '#222222');
                document.documentElement.style.setProperty('--bs-secondary-bg', '#222222');
                document.documentElement.style.setProperty('--navbar-sticky-bg', '#222222');
                document.documentElement.style.setProperty('--flight-search-text-color', '#fff');
                document.documentElement.style.setProperty('--flight-search-input-color', '#fff');
                document.documentElement.style.setProperty('--dropdown-passenger-button-color', '#fff');

                document.documentElement.style.setProperty('--preloader-bg', "#222222");
                document.documentElement.style.setProperty('--loader-border-main', "#d1b26f");
                document.documentElement.style.setProperty('--loader-border-secondary', '#3a3a3a');

                document.documentElement.style.setProperty('--secondary-color', '#3a3a3a');
                document.documentElement.style.setProperty('--primary-color', '#231f20');

                document.documentElement.style.setProperty('--btn-theme-before-bg', '#222222');
                document.documentElement.style.setProperty('--input-bg-color', '#222222');
                document.documentElement.style.setProperty('--area-flex-one-text-color', '#fff');
                document.documentElement.style.setProperty('--flight-inner-show-color', '#fff');
                document.documentElement.style.setProperty('--input-color', '#fff');
                document.documentElement.style.setProperty('--paragraph-color', '#fff');
                document.documentElement.style.setProperty('--dp-background-color', '#3a3a3a');
                document.documentElement.style.setProperty('--flight-search-right-bg', '#555555');
                document.documentElement.style.setProperty('--flight-search-right-bg', '#555555');
                state.logo = ewcLogo;
                
                // cssVars = {
                //     '--main-color': "#d1b26e",
                //     '--bs-body-bg': "#FFFFFF",
                //     '--bg-color': "#F3F6FD",
                //     '--hole-bg-color': "#f0ede8",
                //     '--conf-bg-color': "#d4b87d1c",
                //     '--section-padding-bg': "#fcfcfc",
                //     '--bs-body-color': "#212529",

                //     '--theme-search-form-bg': '#FFFFFF',
                //     '--flight-search-items-bg': '#FFFFFF',
                //     '--flight-search-bg': '#f5f5f5',
                //     '--bs-secondary-bg': '#e9ecef',
                //     '--navbar-sticky-bg': '#ffffff',
                //     '--flight-search-text-color': "#626262",
                //     '--flight-search-input-color': "#000",
                //     '--dropdown-passenger-button-color': "#000",

                //     '--preloader-bg': "rgb(245, 247, 250)",
                //     '--loader-border-main': "rgb(209, 178, 110)",
                //     '--loader-border-secondary': "rgb(243, 243, 243)",

                //     '--secondary-color': '#ecebeb',
                //     '--primary-color': "#f9f9f9",

                //     '--btn-theme-before-bg': '#000000',
                //     '--input-bg-color': '#FFFFFF',
                //     '--area-flex-one-text-color': "#000000",
                //     '--flight-inner-show-color': "#4c4c4c",
                //     '--input-color': "#495057",
                //     '--paragraph-color': "#818090",
                //     '--dp-background-color': '#3a3a3a',
                //     '--flight-search-right-bg': '#f5f5f5',
                // };
                // state.logo = ewcLogo;
                // for (const [key, value] of Object.entries(cssVars)) {
                //     root.style.setProperty(key, value);
                // }
            }
        }
    },
    actions: {
        updateTheme({ commit }, theme) {
            commit('setTheme', theme);
        }
    }
})